<script setup lang="ts"></script>

<template>
   <div class="embed-root">
      <slot />
   </div>
</template>

<!--
   Bare layout for the embeddable widget: no nav, no footer. Intentionally NO <style> block —
   a non-scoped layout style is GLOBAL and leaks into every page's bundle. Any body-level
   styling the embed needs is scoped to a `body.ipolo-embed` class set only by the embed
   page via useHead (see pages/embed/tournaments.vue), so it cannot affect other brands.
-->
